import React, { ChangeEvent, useEffect, useState } from "react";
import cn from "classnames";
import { Icon } from "../../../icons/icon";
import { CircularProgress } from "../../../circular-progress/circular-progress";
import styles from "./text-editable-cell.module.scss";

interface ITextEditableCellProps {
    value?: string;
    className?: string;
    editMode?: boolean;
    editable?: boolean;
    onEdit?: (value: boolean) => void;
    onChange: (value: string) => Promise<boolean>;
}

export const TextEditableCell: React.FC<ITextEditableCellProps> = ({
                                                                       value,
                                                                       onChange,
                                                                       className,
                                                                       editMode,
                                                                       onEdit,
                                                                       editable = true
                                                                   }) => {
    const [isEditMode, setIsEditMode] = useState<boolean>(!!editMode);
    const [valueBeforeEdit, setValueBeforeEdit] = useState<string>(value ?? "");
    const [text, setText] = useState<string>(value ?? "");
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (text !== value) {
            setText(value ?? "");
        }
    }, [value]);

    useEffect(() => {
        setIsEditMode(!!editMode)
    }, [editMode])

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setText(e.target.value);
    };

    const setEdit = (val: boolean) => {
        onEdit && onEdit(val);
        setIsEditMode(val);
    }
    const handleSaveClick = async () => {
        if (onChange) {
            setLoading(true);
            onChange(text).then((success) => {
                if (success) {
                    setEdit(false);
                }
                setLoading(false);
            });
        } else {
            setEdit(false);
        }
    };

    const handleCloseClick = () => {
        setEdit(false);
        setText(valueBeforeEdit);
    };

    const handleEditClick = () => {
        if (editable) {
            setValueBeforeEdit(text);
            setEdit(true);
        }
    };

    return (
        <div className={cn(styles.container, className)}>
            {isEditMode && <div className={styles.inputContainer}>
                <input type="text" value={text} className={styles.input} onChange={handleInputChange}/>
                <div className={styles.buttonBlock}>
                    {!loading && <Icon glyph="check" size="l" onClick={handleSaveClick} className={styles.icon}/>}
                    {!loading && <Icon glyph="close" size="l" onClick={handleCloseClick} className={styles.icon}/>}
                    {loading && <CircularProgress size={20}/>}
                </div>
            </div>}
            {!isEditMode && <div className={cn(styles.textValue, editable ? styles.editable : "")}
                                 onClick={handleEditClick}>{text}</div>}
        </div>
    );
};
